export function parseJSON (text) {
  try {
    return JSON.parse(text)
  } catch (err) {
    console.warn('Expected JSON, got', text)
  }
}
